import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=320b35e7&scoped=true&"
import script from "./AddUser.vue?vue&type=script&lang=ts&"
export * from "./AddUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320b35e7",
  null
  
)

export default component.exports